import {BaseModel} from "@/models/base/BaseModel";
import * as firebase from "firebase";
import Timestamp = firebase.firestore.Timestamp;

export class MaintenanceTemplate extends BaseModel {
  name: string;
  template: string;
  dateTimeCreated: Timestamp;

  constructor(facilityId?: string, name?: string, template?: string) {
    super();
    this.name = name ?? "";
    this.template = template ?? null;
    this.facilityId = facilityId ?? "";
    this.dateTimeCreated = firebase.firestore.Timestamp.now();
  }
}